<template>
    <div>
        <div class="page__bd_spacing" :style="is_submit?'pointer-events:none':''">

            <van-field required v-model="user.user_name" label="姓名" placeholder="请输入姓名" maxlength="50"/>
            <van-field required label="性别" data-name="sex">
                <template #input>
                    <van-radio-group v-model="user.sex" direction="horizontal">
                        <van-radio name="男">男</van-radio>
                        <van-radio name="女">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field required v-model="user.mobile" type="number" label="手机号码" placeholder="请输入手机号码" maxlength="11"/>

            <van-field required v-model="user.company" label="企业名称" placeholder="请输入企业名称" maxlength="100"/>

            <van-field required v-model="user.job" label="现任职务" placeholder="请输入现任职务" maxlength="50"/>

            <van-field required v-model="user.email" label="邮箱" placeholder="请输入邮箱" maxlength="50"/>

            <van-field v-model="user.wechat" label="微信号" placeholder="请输入微信号" maxlength="50"/>

            <van-field v-model="user.address" label="通讯地址" placeholder="请输入通讯地址" maxlength="100"/>
        </div>
        <div class="button" @click="onSave" v-if="!is_submit">提交</div>
        <div class="button btn-no" v-if="is_submit">已提交</div>
    </div>
</template>

<script>
    import { Field,RadioGroup,Radio} from 'vant';
    export default {
        name: "index",
        components:{
            [Field.name]:Field,
            [RadioGroup.name]:RadioGroup,
            [Radio.name]:Radio
        },
        data(){
            return {
                user: {},
                ddrps_id:'',
                is_submit:false
            }
        },
        mounted(){

            this.util.hideOptionMenu();
            this.ddrps_id = this.util.getQueryStr('ddrps_id');

            this.bindGetDdrps();
        },
        methods:{
            bindGetDdrps(){
                var _self=this;
                this.util.server.mini_apply.get({
                    data:{
                        ddrps_id:this.ddrps_id
                    },
                    callback: res => {
                        if(res.data.length == 0){
                            _self.bindGetUserInfo();
                        }else{
                            this.user = res.data;
                            this.is_submit=true;
                        }
                    }
                })
            },
            bindGetUserInfo:function(){
                if(this.util.globalData.user.get() == '' && this.util.sessionid.get() != ''){
                    this.util.server.mini_user.info({
                        callback: res => {
                            this.util.globalData.user.set( res.data);
                            this.util.getUserId.set(res.data.user_id);
                            this.util.user_mobile.set(res.data.mobile);
                            this.user = res.data;
                        }
                    })
                }else{
                    this.user = this.util.globalData.user.get();
                }
            },
            onSave: function(e) {
                var user = this.user;
                var _self=this;

                if (this.util.trim(user.user_name).length < 1) {
                    return this.util.showToast({
                        message: '请输入姓名',
                    });
                }
                if (this.util.trim(user.mobile).length != 11) {
                    return this.util.showToast({
                        message: '请输入手机号码',
                    });
                }
                if (this.util.trim(user.company).length < 2) {
                    return this.util.showToast({
                        message: '请输入企业名称',
                    });
                }
                if (this.util.trim(user.job).length < 2) {
                    return this.util.showToast({
                        message: '请输入现任职务',
                    });
                }
                if (this.util.trim(user.email).length < 2) {
                    return this.util.showToast({
                        message: '请输入邮箱',
                    });
                }
                user['ddrps_id'] = this.ddrps_id;
                user['address']= user['address'] || '';
                user['wechat']= user['wechat'] || '';
                this.util.server.mini_apply.index({
                    data: user,
                    callback: res => {
                        if(res.code == -1){
                            return this.util.showToast({
                                message: res.msg,
                            });
                        }

                        this.util.showToast({
                            message: '提交成功',
                        });
                        setTimeout(function () {
                            if (window.history.length <= 1) {
                                _self.$router.push('/home/index?token='+_self.util.token);
                                return false
                            } else {
                                _self.$router.go(-1)
                            }
                        },1500);
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .required{
        color: #ff3300;
    }
    .btn-no{
        background: #ccc;
    }
</style>
